/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({
    inboxId,
    agentList,
    restrictedAgentList = [],
    restrictedWithContactAgentList = [],
  }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
      restricted_user_ids: restrictedAgentList,
      restricted_with_contact_user_ids: restrictedWithContactAgentList,
    });
  }
}

export default new InboxMembers();
